const shadow = {
    dropdown: '1px 2px 6px rgba(149, 163, 169, 0.4)',
};

export default shadow;
